var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEssE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 2.66667L1.33268 2H14.666L15.3327 2.66667V13.3333L14.666 14H7.33268H5.99935H4.66602H3.33268H1.33268L0.666016 13.3333V2.66667ZM13.9993 12.6667H10V3.33333H13.9993V12.6667ZM8.66602 12.6667H7.33268V3.33333H8.66602V12.6667ZM5.99935 12.6667H4.66602V3.33333H5.99935V12.6667ZM3.33268 12.6667H1.99935V3.33333H3.33268V12.6667ZM13.3327 6H10.6661V4.66667H13.3327V6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3511_31641",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 2.66667L1.33268 2H14.666L15.3327 2.66667V13.3333L14.666 14H7.33268H5.99935H4.66602H3.33268H1.33268L0.666016 13.3333V2.66667ZM13.9993 12.6667H10V3.33333H13.9993V12.6667ZM8.66602 12.6667H7.33268V3.33333H8.66602V12.6667ZM5.99935 12.6667H4.66602V3.33333H5.99935V12.6667ZM3.33268 12.6667H1.99935V3.33333H3.33268V12.6667ZM13.3327 6H10.6661V4.66667H13.3327V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3511_31641)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.66797,
    y: -2.66663,
    width: 21.3333,
    height: 21.3333,
    fill: "#0C74DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssE);
export default __webpack_public_path__ + "static/media/ess_e.1a3d6d22b0790df512969973e31da956.svg";
export { ForwardRef as ReactComponent };